import { Modal, ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { usePaymentMethodsForm } from '../../context/PaymentMethodsFormContext'
import { ModalBody } from './elements/ModalBody'
import { ModalFooter } from './elements/ModalFooter'

export const PaymentMethodsModalComponent = (modalProps: ModalProps): ReactElement => {
  const { t } = useTranslation()
  const { paymentMethodsForm, isProcessing } = usePaymentMethodsForm()
  const { Form: PaymentMethodsFormProvider } = paymentMethodsForm

  return (
    <PaymentMethodsFormProvider>
      <Modal {...modalProps} size="s" closable={!isProcessing}>
        <Modal.Header title={t('external_invoices.payment_methods_modal.title')} />
        <Modal.Body>
          <ModalBody />
        </Modal.Body>
        <Modal.Footer>
          <ModalFooter />
        </Modal.Footer>
      </Modal>
    </PaymentMethodsFormProvider>
  )
}
